export default __webpack_public_path__ + "static/media/pdfScreenshot.c6c49e8a.png";